import { RestApiDataService } from '@/services/api/RestApiDataService'
import { VCheckbox, VTextField } from 'vuetify/lib'
import ImageUploadField from '@/components/ui/crud/fields/ImageUploadField.vue'

const BASE_ENTITY_URL = '/categories'

class CategoryDataService extends RestApiDataService {
  getCrudFields () {
    return [
      { key: 'name', label: 'Название', component: VTextField, rules: ['required'] },
      { key: 'slug', label: 'Slug', component: VTextField },
      { key: 'sortOrder', label: 'Индекс сортировки', component: VTextField, rules: ['number', 'required'], defaultValue: 100 },
      { key: 'ico', label: 'Иконка в листинге', component: ImageUploadField },
      { key: 'topMenuIco', label: 'Иконка в главном меню', component: ImageUploadField },
      { key: 'onlyCrm', label: 'Отображать только в CRM', component: VCheckbox, defaultValue: false },
      { key: 'status', label: 'Категория активна', component: VCheckbox, defaultValue: true },
    ]
  }
}

export default new CategoryDataService(BASE_ENTITY_URL)
